module.exports = __webpack_public_path__ + "static/media/drop-down.de9eb595.svg";